import { render, staticRenderFns } from "./TextBoxField.vue?vue&type=template&id=20a53c78"
import script from "./TextBoxField.vue?vue&type=script&lang=js"
export * from "./TextBoxField.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports